import React from 'react';
import PropTypes from 'prop-types';
import { Button, Tooltip } from 'antd';
import { useDownloadInvoicePreview } from '../../hooks/invoice/useDownloadInvoicePreview';

const InvoicePreviewDownloader = ({ invoiceId, invoiceNo }) => {
  const { loading: downloadingReport, getCaseReportPreview } =
    useDownloadInvoicePreview();

  const handlePreviewReport = async () => {
    await getCaseReportPreview(invoiceId, invoiceNo);
  };

  return (
    <Tooltip title="Download Report Preview" placement="left">
      <Button
        loading={downloadingReport}
        icon={<i className="fa fa-download"></i>}
        onClick={handlePreviewReport}
      ></Button>
    </Tooltip>
  );
};

InvoicePreviewDownloader.propTypes = {
  invoiceId: PropTypes.number,
  invoiceNo: PropTypes.string,
};

export default InvoicePreviewDownloader;
